import API from './api';
import { handleApiError } from './utilsService';

// Servicio para las sedes
const venueService = {
  // Obtener todas las sedes desde PostgreSQL
  getVenues: async (filters = {}) => {
    try {
      console.log('Obteniendo sedes con filtros:', filters);
      const response = await API.get('/postgres/sedes', { params: filters });
      console.log('Respuesta de getVenues:', response);
      return response.data;
    } catch (error) {
      console.error('Error en getVenues:', error);
      throw handleApiError(error, 'Error al obtener las sedes');
    }
  },

  // Obtener una sede por ID desde PostgreSQL
  getVenueById: async (id) => {
    try {
      const response = await API.get(`/postgres/sedes/${id}`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al obtener la sede');
    }
  },

  // Crear una nueva sede (solo admin) - PostgreSQL
  createVenue: async (venueData) => {
    try {
      // Mapear datos del frontend a PostgreSQL
      const sedeData = {
        nombre: venueData.name,
        direccion: venueData.direccion,
        poblacion: venueData.poblacion,
        ubicacion: venueData.ubicacion,
        num_campos_f8: venueData.fieldsF8 || 0,
        num_campos_f11: venueData.fieldsF11 || 0,
        contacto: venueData.contacto,
        latitud: venueData.latitud,
        longitud: venueData.longitud,
        activo: venueData.active !== undefined ? venueData.active : true
      };

      const response = await API.post('/postgres/sedes', sedeData);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al crear la sede');
    }
  },

  // Actualizar una sede (solo admin) - PostgreSQL
  updateVenue: async (id, venueData) => {
    try {
      console.log(`Actualizando sede con ID ${id} con datos:`, venueData);
      if (!id) {
        console.error('Error: ID de sede no válido');
        throw new Error('ID de sede no válido');
      }

      // Mapear datos del frontend a PostgreSQL
      const sedeData = {};
      if (venueData.name !== undefined) sedeData.nombre = venueData.name;
      if (venueData.direccion !== undefined) sedeData.direccion = venueData.direccion;
      if (venueData.poblacion !== undefined) sedeData.poblacion = venueData.poblacion;
      if (venueData.ubicacion !== undefined) sedeData.ubicacion = venueData.ubicacion;
      if (venueData.fieldsF8 !== undefined) sedeData.num_campos_f8 = venueData.fieldsF8;
      if (venueData.fieldsF11 !== undefined) sedeData.num_campos_f11 = venueData.fieldsF11;
      if (venueData.contacto !== undefined) sedeData.contacto = venueData.contacto;
      if (venueData.latitud !== undefined) sedeData.latitud = venueData.latitud;
      if (venueData.longitud !== undefined) sedeData.longitud = venueData.longitud;
      if (venueData.active !== undefined) sedeData.activo = venueData.active;

      const response = await API.put(`/postgres/sedes/${id}`, sedeData);
      console.log(`Respuesta de updateVenue(${id}):`, response);
      return response.data;
    } catch (error) {
      console.error(`Error en updateVenue(${id}):`, error);
      throw handleApiError(error, 'Error al actualizar la sede');
    }
  },

  // Eliminar una sede (solo admin)
  deleteVenue: async (id) => {
    try {
      console.log(`Eliminando sede con ID ${id}...`);
      if (!id) {
        console.error('Error: ID de sede no válido');
        throw new Error('ID de sede no válido');
      }
      const response = await API.delete(`/postgres/sedes/${id}`);
      console.log(`Respuesta de deleteVenue(${id}):`, response);
      return response.data;
    } catch (error) {
      console.error(`Error en deleteVenue(${id}):`, error);
      throw handleApiError(error, 'Error al eliminar la sede');
    }
  },

  // Añadir una reseña a una sede
  addVenueReview: async (id, reviewData) => {
    try {
      const response = await API.post(`/venues/${id}/reviews`, reviewData);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al añadir la reseña');
    }
  },

  // Obtener estadísticas de sedes (solo admin)
  getVenueStats: async () => {
    try {
      const response = await API.get('/venues/stats');
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al obtener las estadísticas de sedes');
    }
  },

  // Obtener disponibilidad de una sede
  getVenueAvailability: async (id, date) => {
    try {
      const response = await API.get(`/venues/${id}/availability`, { params: { date } });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al obtener la disponibilidad de la sede');
    }
  },

  // Obtener partidos programados en una sede
  getVenueMatches: async (id, filters = {}) => {
    try {
      const response = await API.get(`/venues/${id}/matches`, { params: filters });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al obtener los partidos de la sede');
    }
  },

  // Subir imagen de una sede (solo admin)
  uploadVenueImage: async (id, imageFile) => {
    try {
      const formData = new FormData();
      formData.append('image', imageFile);

      const response = await API.post(`/venues/${id}/image`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al subir la imagen de la sede');
    }
  },

  // Activar una sede (solo admin)
  activateVenue: async (id) => {
    try {
      const response = await API.put(`/venues/${id}/activate`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al activar la sede');
    }
  },

  // Desactivar una sede (solo admin)
  deactivateVenue: async (id) => {
    try {
      const response = await API.put(`/venues/${id}/deactivate`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al desactivar la sede');
    }
  },

  // Obtener sedes cercanas a una ubicación
  getNearbyVenues: async (lat, lng, maxDistance = 10) => {
    try {
      const response = await API.get('/venues/nearby', {
        params: { lat, lng, maxDistance },
      });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al obtener sedes cercanas');
    }
  },

  // Obtener sedes disponibles (activas)
  getActiveVenues: async () => {
    try {
      const response = await API.get('/venues', {
        params: { active: true },
      });

      // Extraer las sedes del objeto de respuesta
      const data = response.data;
      if (data && data.venues) {
        return data.venues;
      }

      // Si la respuesta es directamente un array, devolverlo
      if (Array.isArray(data)) {
        return data;
      }

      return [];
    } catch (error) {
      return [];
    }
  },

  // ── Campos (instalaciones físicas dentro de una sede) ──────────────────────

  // Obtener campos de una sede (?activo=all para todos, por defecto solo activos)
  getCamposBySede: async (sedeId, params = {}) => {
    try {
      const response = await API.get(`/postgres/sedes/${sedeId}/campos`, { params });
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al obtener los campos de la sede');
    }
  },

  // Crear campo dentro de una sede
  createCampo: async (sedeId, campoData) => {
    try {
      const response = await API.post(`/postgres/sedes/${sedeId}/campos`, campoData);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al crear el campo');
    }
  },

  // Actualizar campo
  updateCampo: async (sedeId, campoId, campoData) => {
    try {
      const response = await API.put(`/postgres/sedes/${sedeId}/campos/${campoId}`, campoData);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al actualizar el campo');
    }
  },

  // Desactivar campo (soft delete)
  deleteCampo: async (sedeId, campoId) => {
    try {
      const response = await API.delete(`/postgres/sedes/${sedeId}/campos/${campoId}`);
      return response.data;
    } catch (error) {
      throw handleApiError(error, 'Error al desactivar el campo');
    }
  },

  // ────────────────────────────────────────────────────────────────────────────

  // Métodos adaptados para useCRUD hook
  getAll: (filters = {}) => {
    return venueService.getVenues(filters);
  },

  create: (data) => {
    return venueService.createVenue(data);
  },

  update: (id, data) => {
    return venueService.updateVenue(id, data);
  },

  delete: (id) => {
    return venueService.deleteVenue(id);
  },

  getById: (id) => {
    return venueService.getVenueById(id);
  }
};

export default venueService;
